const CREDIT_TYPES = {
    ARTIST: 'Artist',
    PRODUCER: 'Producer',
    DIRECTOR: 'Director',
};

export default CREDIT_TYPES;
